export const staticRouters = [
  // 页面404
  {
    path: '*',
    name: '404',
    component: () => import('@/views/Exception/404.vue'),
    meta:{
      title:'Not found'
    }
  },
  // 登录
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login'),
    meta:{
      title:'登录'
    }
  },
  // 主要内容模块
  {
    path: '/home',
    component: () => import('@/layout/Home.vue'),
    children: [
      // 首页
      {
        path: '',
        name: 'home',
        component: () => import('@/views/Home'),
        meta:{
          title:'首页'
        }
      },
      // 我的购物车
      {
        path: '/home/shopcar',
        name: "shopcar",
        component: () => import('@/views/ShopCar'),
        meta:{
          title:'购物车'
        }
      },
      // 购物车详情
      {
        path: '/home/shopcardet',
        name: 'shopcardet',
        component: () => import('@/views/ShopCardet'),
        meta:{
          title:'详情页'
        }
      },
      // 订单结算
      {
        path: '/home/shopsesttle',
        name: 'shopsesttle',
        component: () => import('@/views/ShopSettle'),
        meta:{
          title:'订单结算'
        }
      },
      
      // 订单结算
      {
        path: '/home/shoporderlist',
        name: 'shoporderlist',
        component: () => import('@/views/OrderDet'),
        meta:{
          title:'订单详情查看'
        }
      },
      // // 订单详情
      // {
      //   path: '/home/orderdetail',
      //   name: 'orderdetail',
      //   component: () => import('@/views/OrderDet'),
      //   meta:{
      //     title:'订单详情'
      //   }
      // },
      // 公告详情
      {
        path: '/home/announcementdet',
        name: 'announcementdet',
        component: () => import('@/views/Announcement'),
        meta:{
          title:'公告详情'
        }
      },
      // 主要内容服务中心模块
      {
        path: '/home/contentmain',
        component: () => import('@/layout/ContentMain.vue'),
        children: [
          // 我的订单
          {
            path: '',
            component: () => import('@/views/contentmain/MyOrder/MyOrder.vue'),
            meta:{
              title:'我的订单',
              keepAlive: true
            }
          },
           // 发货详情
           {
            path: '/home/main/deliveryDetail',
            component: () => import('@/views/contentmain/MyOrder/Components/deliveryDetail.vue'),
            meta:{
              title:'发货详情'
            }
          },
           // 发货明细详情
           {
            path: '/home/main/deliveryDetailsInfo',
            name: 'deliveryDetailsInfo',
            component: () => import('@/views/contentmain/MyOrder/Components/deliveryDetailsInfo.vue'),
            meta:{
              title:'发货单明细'
            }
          },
          // 收货
          {
            path: '/home/main/theGoods',
            component: () => import('@/views/contentmain/MyOrder/Components/theGoods.vue'),
            meta:{
              title:'收货'
            }
          },
          // 我的余额
          {
            path: '/home/main/fundsituation',
            component: () => import('@/views/contentmain/FundSituation.vue'),
            meta:{
              title:'我的余额'
            }
          },
          // // 终端要货清单
          // {
          //   path: '/home/main/terminalorderlist',
          //   component: () => import('@/views/contentmain/TerminalOrderlist.vue'),
          //   meta:{
          //     title:'终端要货清单'
          //   }
          // },
           // 我的发货单
           {
            path: '/home/main/mydeliveryorder',
            component: () => import('@/views/contentmain/MyDeliveryOrder.vue'),
            meta:{
              title:'我的发货单'
            }
          },
           // 分销订单
           {
            path: '/home/main/distributionorder',
            component: () => import('@/views/contentmain/distributionorder.vue'),
            meta:{
              title:'分销订单'
            }
          },
           // 库存管理
           {
            path: '/home/main/inventory',
            component: () => import('@/views/contentmain/inventory.vue'),
            meta:{
              title:'库存管理'
            }
          },
          // 终端要货清单详情
          {
            path: '/home/main/terminallistdet',
            component: () => import('@/views/contentmain/TerminallistDet.vue'),
            meta:{
              title:'要货详情'
            }
          },
          // 收藏夹
          {
            path: '/home/main/favorites',
            component: () => import('@/views/contentmain/Favorites.vue'),
            meta:{
              title:'收藏夹'
            }
          },
          // 客户对账函
          {
            path: '/home/main/customer',
            component: () => import('@/views/contentmain/CustomerReconciliation.vue'),
            meta:{
              title:'客户对账函'
            }
          },
          // 对账联系函
          {
            path: '/home/main/reconletter',
            component: () => import('@/views/contentmain/ReconciliationContactletter.vue'),
            meta:{
              title:'客户对账函'
            }
          },
          // 资金明细查询
          {
            path: '/home/main/fundDetail',
            component: () => import('@/views/contentmain/FundDetail.vue'),
            meta:{
              title:'资金明细'
            }
          },
          // 折扣明细查询
          {
            path: '/home/main/discountDetail',
            component: () => import('@/views/contentmain/DiscountDetail.vue'),
            meta:{
              title:'折扣明细'
            }
          },
          // 货补明细查询
          {
            path: '/home/main/goodsDetail',
            component: () => import('@/views/contentmain/GoodsDetail.vue'),
            meta:{
              title:'货补明细'
            },
          },
          // 任务查询
          {
            path: '/home/main/replenishmentdetails',
            component: () => import('@/views/contentmain/Replenishmentdetails.vue'),
            meta:{
              title:'任务查询'
            },
          },
          //任务详情
          {
            path: '/home/main/taskDetail',
            component: () => import('@/views/contentmain/taskDetail.vue'),
            meta:{
              title:'任务详情'
            },
          },

          // 公司证件
          {
            path: '/home/main/company',
            component: () => import('@/views/contentmain/CompanyView.vue'),
            meta:{
              title:'公司证件'
            },
          },
          // 修改密码
          {
            path: '/home/main/changepass',
            component: () => import('@/views/contentmain/ChangePass.vue'),
            meta:{
              title:'修改密码'
            },
          },
          // 公告查看
          {
            path: '/home/main/announcement',
            component: () => import('@/views/contentmain/AnnouncementView.vue'),
            meta:{
              title:'公告查看'
            },
          },
          // 合同管理
          {
            path: '/home/main/contractManage',
            component: () => import('@/views/contentmain/ContractManage.vue'),
            meta:{
              title:'合同管理'
            },
          },
          // 合同详情
          {
            path: '/home/main/contractManageDet',
            component: () => import('@/views/contentmain/ContractManageDet/ContractManageDet.vue'),
            meta:{
              title:'合同详情'
            },
          },
          // 系统设置
          {
            path: '/home/main/system',
            component: () => import('@/views/contentmain/SystemSettings'),
            meta:{
              title:'系统设置'
            },
          },
          // 告知函
          {
            path: '/home/main/notify_letter',
            component: () => import('@/views/contentmain/notify_letter.vue'),
            meta:{
              title:'告知函'
            }
          }
        ]
      }
    ]
  },
]